import React, { MouseEventHandler, useEffect } from 'react'
import Input from '../../components/Input'
import Form from '../../components/Form'
import { FORM_CONTRACTOR } from '../../utils/constans'
import FormFooter from '../../components/FormFooter'
import { Backdrop } from '@mui/material'
import Progress from '../../components/Progress'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'
import { ContractorForm } from 'contractors'
import { Option } from '../../types'
import { InputFields } from 'forms'

interface Props {
    onSubmit: SubmitHandler<ContractorForm>
    onCancel: MouseEventHandler<HTMLAnchorElement>
    options?: { [name: string]: Array<Option> | undefined }
    initialValues?: ContractorForm
    onSubmitText: string
    loading: boolean
}

const FormContractors = ({
    onCancel,
    options,
    initialValues,
    onSubmitText,
    loading,
    onSubmit,
}: Props) => {
    const methods = useForm<ContractorForm>()
    const { handleSubmit, reset } = methods

    useEffect(() => {
        reset(initialValues)
    }, [initialValues, reset])

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <>
                    {FORM_CONTRACTOR.map(
                        ({ name, type, label, placeholder, isRequired }: InputFields, i) => (
                            <Input
                                key={i}
                                name={name}
                                type={type}
                                label={label}
                                placeholder={placeholder}
                                isRequired={isRequired}
                            />
                        )
                    )}
                    <FormFooter
                        onSubmitText={onSubmitText || 'OK'}
                        onCancel={onCancel}
                        onSubmitDisable={loading}
                    />
                    <Backdrop open={loading} invisible={true}>
                        <Progress />
                    </Backdrop>
                </>
            </Form>
        </FormProvider>
    )
}

export default FormContractors
